import { render, staticRenderFns } from "./ComplementaryIndicator.vue?vue&type=template&id=7ca27acc"
import script from "./ComplementaryIndicator.vue?vue&type=script&lang=js"
export * from "./ComplementaryIndicator.vue?vue&type=script&lang=js"
import style0 from "./ComplementaryIndicator.vue?vue&type=style&index=0&id=7ca27acc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports